var React = require('react');

function LiveTv (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"3","width":"18","height":"13","rx":"1","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"8","y1":"21","x2":"16","y2":"21","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M12 16L12 20","stroke":"currentColor","strokeWidth":"2","key":2}),React.createElement("circle",{"cx":"12","cy":"9.5","r":"3","fill":"currentColor","key":3})]);
}

LiveTv.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LiveTv;

LiveTv.default = LiveTv;
